
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const getOpenAIKey = async (): Promise<string> => {
  try {
    // For the frontend, we just check if there's a custom key in settings
    // The actual API key is now securely stored in Supabase secrets and used by edge functions
    
    // Try to get a settings override from the database (for admin purposes)
    const { data: defaultData, error: defaultError } = await supabase
      .from('settings')
      .select('openai_api_key')
      .eq('user_id', 'default')
      .maybeSingle();

    if (defaultError) { 
      // Return indication that we have a key (the secure one in edge functions)
      return 'configured';
    }

    // If there's a valid key in the database settings, use that (allows for admin override)
    if (defaultData?.openai_api_key) {
      return defaultData.openai_api_key;
    }

    // Return indication that we have a key configured securely
    return 'configured';
  } catch (error) {
    // Return indication that we have a key configured securely
    return 'configured';
  }
};

export const saveOpenAIKey = async (key: string): Promise<void> => {
  try {
    // In a SAAS solution, we're only updating the global default key
    // This function would typically only be used by administrators
    const userId = 'default';
    
    // Cast types for TypeScript - match the exact schema types
    const settingsData = {
      user_id: userId,
      openai_api_key: key
    };
    
    // Save OpenAI API key to Supabase
    const { error } = await supabase
      .from('settings')
      .upsert(settingsData as any, { 
        onConflict: 'user_id' 
      });

    if (error) {
      toast.error('Failed to save OpenAI API key');
      throw new Error(`Failed to save OpenAI API key: ${error.message}`);
    }

    toast.success('OpenAI API key saved successfully!');
  } catch (error) {
    toast.error('An error occurred while saving OpenAI API key');
    throw error;
  }
};
